import 'whatwg-fetch';
import {notifyFetchErrors} from 'utilities/fetch';
import getCSRFToken from 'utilities/security/token-fetcher';

const BASE_URI = '/services_marketplace/taxonomy';

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
  'X-CSRF-Token': getCSRFToken(),
};

const options = {
  headers,
  credentials: 'same-origin',
};

export function getServices() {
  const URL = `${BASE_URI}/services`;

  return fetch(URL, options)
    .then(notifyFetchErrors('ServicesMarketplace::FetchServicesError'))
    .then(response => response.json());
}
